import { render, staticRenderFns } from "./WorldInvoiceView2.vue?vue&type=template&id=471bbf70&scoped=true&"
import script from "./WorldInvoiceView2.vue?vue&type=script&lang=js&"
export * from "./WorldInvoiceView2.vue?vue&type=script&lang=js&"
import style0 from "./WorldInvoiceView2.vue?vue&type=style&index=0&id=471bbf70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471bbf70",
  null
  
)

export default component.exports